<script lang="ts">
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    import _isToday from 'dayjs/plugin/isToday'
    dayjs.extend(_isToday)
    import { onMount } from 'svelte'
    import 'dayjs/locale/pt-br'
    import type { User } from '../../modules/usersApi/users/user'
    import DashboardProductivityBarItem from './dashboard-productivity-bar-item.svelte'
    import Fa from 'svelte-fa'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope, faPhone, faSms } from '@fortawesome/free-solid-svg-icons'
    dayjs.locale('pt-br')
    //dayjs.extend(utc)

    let range = 30

    export let start: number
    export let end: number
    export let userEvents: { user: User; events: any[] }
    export let onlySuccess = false
    export let byTime = false
    onMount(async () => {
        //loadBar()
    })

    $: {
        loadBar(userEvents)
    }

    let show = true
    let slots: {
        time: number
        wa: { total: number; items: { name: string; recipient: string; value: number }[] }
        phone: { total: number; items: { name: string; recipient: string; value: number }[] }
        email: { total: number; items: { name: string; recipient: string; value: number }[] }
        sms: { total: number; items: { name: string; recipient: string; value: number }[] }
    }[] = []
    function loadBar(ue) {
        show = true
        slots = []
        for (let current = start; current < end; current += range) {
            let slot: {
                time: number
                wa: { total: number; items: { name: string; recipient: string; value: number }[] }
                phone: { total: number; items: { name: string; recipient: string; value: number }[] }
                email: { total: number; items: { name: string; recipient: string; value: number }[] }
                sms: { total: number; items: { name: string; recipient: string; value: number }[] }
            } = {
                time: current,
                wa: { total: 0, items: [] },
                phone: { total: 0, items: [] },
                email: { total: 0, items: [] },
                sms: { total: 0, items: [] },
            }
            for (const event of ue.events) {
                if (minutes(event.externalDate) >= current && minutes(event.externalDate) < current + range) {
                    if (event.source === 'voip' || event.source === 'celular' || event.source === 'telefone') {
                        let found = slot.phone.items.find((el) => el.recipient === event.person.phone)
                        slot.phone.items.push({
                            name: event.person.name,
                            recipient: event.person.phone,
                            value: event.value,
                        })
                    }
                    if (event.source === 'whatsapp') {
                        let found = slot.wa.items.find((el) => el.recipient === event.person.phone)
                        if (found) {
                            found.value += 1
                        } else {
                            slot.wa.items.push({
                                name: event.person.name,
                                recipient: event.person.phone,
                                value: 1,
                            })
                        }
                    }
                    if (event.source === 'email') {
                        slot.email.items.push({
                            name: event.person.name,
                            recipient: event.person.email,
                            value: event.value,
                        })
                    }
                    if (event.source === 'sms') {
                        slot.sms.items.push({
                            name: event.person.name,
                            recipient: event.person.phone,
                            value: event.value,
                        })
                    }
                }
            }
            slots.push(slot)
        }
        console.log('slots', slots)
        evaluateOnlySuccess()
        slots = slots
        show = false
    }

    function evaluateOnlySuccess() {
        if (!onlySuccess) return
        for (let slot of slots) {
            // wa
            for (let index = slot.wa.items.length - 1; index >= 0; index--) {
                let item = slot.wa.items[index]
                if (item.value < 5) {
                    slot.wa.items.splice(index, 1)
                    slot.wa.total -= 1
                }
            }
            // phone
            for (let index = slot.phone.items.length - 1; index >= 0; index--) {
                let item = slot.phone.items[index]
                if (item.value < 60) {
                    slot.phone.items.splice(index, 1)
                    slot.phone.total -= 1
                }
            }
        }
    }

    function minutes(date: Date) {
        return date.getHours() * 60 + date.getMinutes()
    }
</script>

<div class="list">
    <div class="list-header">
        <div class="title">{userEvents.user.userName}</div>
        <div class="icons">
            <div class="icon time" />
            <div class="icon">
                <Fa icon={faWhatsapp} />
            </div>
            <div class="icon">
                <Fa icon={faPhone} />
            </div>
            <!-- <div class="icon">
                <Fa icon={faSms} />
            </div> -->
            <div class="icon">
                <Fa icon={faEnvelope} />
            </div>
        </div>
    </div>
    <div class="list-body">
        {#each slots as slot, i}
            <DashboardProductivityBarItem {byTime} {slot} />
        {/each}
    </div>
</div>

<style>
    .list {
        display: flex;
        flex-direction: column;
        flex: 0 0 336px;
        /* margin-right: 8px; */
        border-right: 0px solid #99999940;
        background-color: #99999910;
        border-radius: 6px;
    }
    .list-header {
        padding: 4px 0px;
        opacity: 0.8;
        background: #99999922;
    }
    .list-header .title {
        text-align: center;
        padding-bottom: 8px;
    }
    .list-header .icons {
        display: flex;
    }
    .list-header .icons .time {
        display: flex;
        flex: 0 0 50px;
    }
    .list-header .icons > * {
        flex: 1 1 1px;
        text-align: center;
    }
    .list-body {
        border: 0px dashed #99999922;
        flex-grow: 1;
        border-radius: 8px;
        position: relative;
    }

    @media (max-width: 900px) {
        .list {
            flex: 0 0 400px;
        }
    }
    @media (min-width: 1367px) {
        .list {
            flex: 0 0 310px;
        }
    }
</style>
